// Change font size
const fonts = {
	small: '50%',
	normal: '62.5%',
	big: '100%',
};

function setContentMargin() {
	if (document.getElementById('header')) {
		const headerHeight = document.getElementById('header').clientHeight;
		document.getElementById('content').style.marginTop = `calc(${headerHeight}px)`;
	}
}

if (localStorage.getItem('contrast') === 'true') {
	document.body.classList.add('contrast');
}
const fontsize = localStorage.getItem('fontsize');
if (fontsize) {
	document.querySelector('html').style.setProperty('font-size', fonts[fontsize]);
	setContentMargin();
}

document.querySelectorAll('.font-size-btn').forEach((item) => {
	item.addEventListener('click', function (e) {
		const type = e.target.getAttribute('data-fontsize');
		localStorage.setItem('fontsize', type);
		document.querySelector('html').style.setProperty('font-size', fonts[type]);
		setContentMargin();
	});
});

setContentMargin();

// Change contrast
document.getElementById('contrast-btn')?.addEventListener('click', function () {
	if (document.body.classList.contains('contrast')) {
		document.body.classList.remove('contrast');
		localStorage.removeItem('contrast');
	} else {
		document.body.classList.add('contrast');
		localStorage.setItem('contrast', 'true');
	}
});

// Hide top header on scroll
let ticking = false;

document.addEventListener('scroll', function () {
	const scrollPosition = window.scrollY;

	if (!ticking) {
		window.requestAnimationFrame(function () {
			if (scrollPosition) {
				document.getElementById('header-top-wrapper')?.classList.add('header-top-wrapper--hidden');
			} else {
				document.getElementById('header-top-wrapper')?.classList.remove('header-top-wrapper--hidden');
			}

			ticking = false;
		});

		ticking = true;
	}
});
